import { render, staticRenderFns } from "./CreateProjectTypeModal.vue?vue&type=template&id=79b2c310&scoped=true&"
import script from "./CreateProjectTypeModal.vue?vue&type=script&lang=js&"
export * from "./CreateProjectTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b2c310",
  null
  
)

export default component.exports